module.exports = __webpack_public_path__ + "img/businesstoday.bd17ff1a.svg";